// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608271134/js/" + chunkId + "." + {"44":"520f5301","225":"22c3c538","481":"968e4935","486":"6c792f88","770":"cb7599a9"}[chunkId] + ".0.44402211994004626.chunk.js";
};